import mitt from 'mitt'

const emitter = mitt()

export default emitter

// import eventModule from '@/assets/libs/eventModule'
// eventModule.emit('eventName', eventData)
// created() {
//     eventModule.$on('eventName', this.callback)
// },
// beforeDestroy() {
//     eventModule.$off('eventName', this.callback);
// },
